import { useMemo } from "react";
import styles from "./ToolDetails.module.css";

import { useNavigate, useParams } from "react-router-dom";
import { useFetch } from "shared/utils/useFetch";

import Collaborate from "features/collaborate";
import PersonalDetails from "features/personal-details";
import SectionHeader from "shared/components/Header/SectionHeader";
import ToolCard from "shared/components/ToolCard";
import { shuffleArray } from "shared/utils/collection";
import { formatRouteLabel } from "shared/utils/text";

const ToolContent = ({
  toolName,
  overview = null,
  usage = null,
  reasoning = null,
}) => {
  return (
    <div>
      {overview && (
        <h2 className={`${styles.header} ${styles.overview}`}>Overview</h2>
      )}
      {usage && <h2 className={styles.header}>{`How I Use ${toolName}`}</h2>}
      {reasoning && <h2 className={styles.header}> {`Why ${toolName}`}</h2>}
      <p className={styles.context}>{overview || usage || reasoning}</p>
    </div>
  );
};

const ToolDetails = () => {
  const navigate = useNavigate();
  const { toolName } = useParams();
  const { data: tools } = useFetch("/api/tools", []);

  const tool = useMemo(
    () => tools.find((item) => item.title === toolName),
    [tools, toolName]
  );
  const displayToolName = formatRouteLabel(toolName);
  const goToTools = () => navigate("/tools");

  const relatedTools = useMemo(
    () =>
      shuffleArray(tools.filter((item) => item.title !== toolName)).slice(0, 4),
    [tools, toolName]
  );

  if (!tool) {
    return (
      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.personalDetails}>
            <PersonalDetails />
          </div>
          <div className={styles.detailsContainer}>
            <button type="button" onClick={goToTools} className={styles.backButton}>
              &#8592; All Tools
            </button>
            <div className={styles.outletWrapper}>
              <h1>Tool Not Found</h1>
              <p>The tool you're looking for doesn't exist.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <div className={styles.row}>
        <div className={styles.personalDetails}>
          <PersonalDetails />
        </div>

        <div className={styles.detailsContainer}>
          <button type="button" onClick={goToTools} className={styles.backButton}>
            &#8592; All Tools
          </button>

          <div className={styles.outletWrapper}>
            <div className={styles.toolTitleContainer}>
              <img
                className={styles.toolImage}
                src={tool.logo}
                alt={`${tool.title} logo`}
              />

              <h1 className={styles.title}>{displayToolName}</h1>
            </div>

            <ToolContent toolName={displayToolName} overview={tool.content.overview} />
            <ToolContent toolName={displayToolName} usage={tool.content.usage} />
            <ToolContent
              toolName={displayToolName}
              reasoning={tool.content.reasoning}
            />

            <SectionHeader
              title="More tools"
              isTextBold={false}
              className={styles.header}
            />
            <div className={styles.toolsContainer}>
              {relatedTools.map((relatedTool) => (
                <ToolCard key={relatedTool.id} tool={relatedTool} />
              ))}
            </div>
          </div>
        </div>
        <div className={styles.collabContainer}>
          <Collaborate />
        </div>
      </div>
    </div>
  );
};

export default ToolDetails;
